import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { DeeplinkService } from '@rci/self-serve-fido/core/deeplink/deeplink.service';
import { LoginStateFacade } from '@rci/self-serve-fido/core/fido-login-state/login-state.facade';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SIGNIN_URL = '/profile/signin';
@Injectable({
  providedIn: 'root',
})
export class SigninGuard implements CanActivate {
  private readonly deeplinkService = inject(DeeplinkService);
  private readonly loginStateFacade = inject(LoginStateFacade);
  private readonly routingService = inject(RoutingService);

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.loginStateFacade.getLoginState$().pipe(
      map(loginState => {
        if (!loginState.isUserAuthenticated) {
          this.deeplinkService.storeDeeplinkState(state);
          this.routingService.navigate(SIGNIN_URL);
        }
        return loginState.isUserAuthenticated;
      }),
    );
  }
}
